module.exports = __webpack_public_path__ + "static/media/J.0813e384.svg";